export const CARD_CONTAINER_WITH_BACKGROUND_CLASS =
    " aspect-square  bg-center	bg-cover";
export const INNER_CARD_CONTAINER_WITH_BACKGROUND_CLASS =
    "aspect-square flex flex-col justify-end p-3 sm:p-5 h-full w-full opacity-80 bg-dark-gradient";
export const CARD_INNER_CONTAINER_CLASS = "";
export const VIEW_PROFILE_TEXT = "VIEW PROFILE";
